import EmailFooterPage from "../../components/Pages/Settings/EmailTemplates/EmailFooter";

const EmailFooter = () => {
  return (
    <div>
      <EmailFooterPage />
    </div>
  );
};

export default EmailFooter;
